import { getFirestore } from "firebase/firestore";
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyD2Vj9ABU3aq8ES6EKPHKiKSLx9poO1iA0",
  authDomain: "cr11-e9a7e.firebaseapp.com",
  projectId: "cr11-e9a7e",
  storageBucket: "cr11-e9a7e.firebasestorage.app",
  messagingSenderId: "417085912794",
  appId: "1:417085912794:web:aedf6f6972ae882bf897e3",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const fdb = getFirestore(app);

const fAuth = getAuth();

export { fdb, fAuth };
